/* RSC */

import { css } from '@bts-web/utils-style-engine';
import { PropsWithChildren, ReactElement } from 'react';
import { ErrorMessage } from '../../common/components';

interface ErrorPageProps extends PropsWithChildren {
  title: string | ReactElement;
  description?: string | ReactElement;
  withRetryButton?: boolean;
}

const ErrorPage = (props: ErrorPageProps) => (
  <div
    data-testid="error-page"
    className={css({
      display: 'flex',
      alignItems: 'center',
      minHeight: '100vh',
      justifyContent: 'center',
      gap: 0,
    })}
  >
    <ErrorMessage {...props} />
  </div>
);

export { ErrorPage };
